import React from 'react';
import styled from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';


const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

const Home = () => {
  return (
    <Container>
      <Title>KaliMeNope.de</Title>
      <h1>Webentwicklung mit React und Elektrotechnik</h1>
      
    </Container>
  );
};

export default Home;